import {EFormHelper} from './helper';
import {TranslateService} from '@ngx-translate/core';

export class ErorsMessage {
   helper = new EFormHelper();

   constructor(public translate: TranslateService) {
   }

   msgErrors(eform, sectionIndex, fieldIndex, type, options?, tableIndex?, typeField?) {
      let controls, numberType;
      if (tableIndex === -1 || (!tableIndex && tableIndex !== 0)) {
         controls = this.helper.getFieldAsFormGroupWithIndex(eform, sectionIndex, fieldIndex)?.get(type);
         numberType = this.helper.getFieldValue(eform, sectionIndex, fieldIndex);
      } else {
         controls = this.helper.getFieldTableAsFormGroupWithIndex(eform, sectionIndex, fieldIndex, tableIndex)?.get(type);
         numberType = this.helper.getFieldTableValue(eform, sectionIndex, fieldIndex, tableIndex);
      }
      let error = '';
      switch (type) {
         case 'fieldName': error = this.validateFieldName(controls, typeField); break;
         case 'rangeStart': error = this.validateRange(controls, {options: options, base: 'min'}, numberType.type); break;
         case 'rangeEnd': error = this.validateRange(controls, {options: options, base: 'max'}, numberType.type); break;
         case 'minItem': error = this.validateRange(controls, {options: options, base: 'min'}); break;
         case 'maxItem': error = this.validateRange(controls, {options: options, base: 'max'}); break;
         default: break;
      }
      return error;
   }

   validateFieldName(controls, type) {
      let _text = '';
      this.translate.get('eform.errors').subscribe(msg => {
         if (controls?.hasError('required')) {
            _text = msg['no-field-' + type];
         } else if (controls?.hasError('existing')) {
            _text = msg['existing-' + type];
         }
      });

      return _text;
   }

   validateRange(controls, options, type?) {
      if (!controls) {
         return '';
      }

      let _text = '';
      this.translate.get('eform.errors').subscribe(msg => {
         if (controls?.hasError('required')) {
            _text = msg['no-range'];
         } else if (controls?.hasError('mustNotBeDash')) {
            _text = msg['invalid-input-value'];
         } else if (controls?.hasError('mustBeInteger') || controls?.hasError('mustBeDecimal')) {
            switch (type) {
               case 'integer':  _text = msg['decimal-must-integer']; break;
               default: this.translate.get('eform.errors.decimal-not-macth', {decimal: options.options}).subscribe(msg => {
                  _text = msg;
               }); break;
            }
         } else if (controls?.hasError('badRangeValue') || controls?.hasError('range')) {
            _text = (options.base === 'min') ? msg['decimal-invalid-min-range'] : msg['decimal-invalid-max-range'];
         }
      });

      if (controls?.hasError('decimalNotMath')) {
         this.translate.get('eform.errors.decimal-not-macth', {decimal: options.options}).subscribe(msg => {
            _text = msg;
         });
      }

      return _text;
   }

}
